<div class="modal-header">
	<div class="d-flex justify-content-between align-items-start w-100">
		<div>
			<h5 class="modal-title mb-1">{{'shipment.invoice.attachInvoice' | cxTranslate}}</h5>
			<h6 class="text-secondary mb-0">{{ batchData?.formattedNominationNumber || batchData?.batchId || '-- --' }}</h6>
		</div>
		 <div class="d-flex align-items-center">
				<span class="badge badge-warning mr-3" [ngStyle]="{
            'background-color': (invoiceResponse?.azureStatus | lowercase) === 'success' ? '#28A745' :
                                (invoiceResponse?.azureStatus | lowercase) === 'rejected' ? '#663366' :
                                (invoiceResponse?.azureStatus | lowercase) === 'in_progress' ? '#f77f00' :
                                (invoiceResponse?.azureStatus | lowercase) === 'failure' ? '#dc3545' :
                                '#f77f00',
            'color': '#fff',
            'font-size': '0.85rem',
            'padding': '6px 10px'
        }">{{ invoiceResponse?.azureShowStatus}}</span>
				<button type="button" class="close" aria-label="Close" (click)="onClose()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
	</div>
</div>

<div id="loader" *ngIf="enableLoader" class="overlay-loader loading-spinner"></div>

	<div class="modal-body"  *ngIf="!enableLoader">
	<div class="row mb-3">
		<div class="col-dir col-md-12 pb-3" *ngIf="showConfirmation">
			<span class="pb-2 xs-semibold-font ml-0">{{'shipment.invoice.PleaseConfirmBeforeSubmitting' | cxTranslate}}</span>
		</div>
		<div class="col-md-3 col-sm-12 mb-3 mb-md-0">
			<label class="labelClass small strong text-secondary mb-1">{{'shipment.invoice.vesselName' | cxTranslate}}</label>
			<p class="fieldClass mb-0 attach-value">{{ batchData?.vesselName || '-- --' }}</p>
		</div>
		<div class="col-md-4 col-sm-12 mb-3 mb-md-0">
			<label class="labelClass small strong text-secondary mb-1">{{'shipment.invoice.dischargePort' | cxTranslate}}</label>
			<p class="fieldClass mb-0 attach-value">{{ batchData?.portName || batchData?.port || '-- --' }}</p>
		</div>
		<div class="col-md-5 col-sm-12">
			<label class="labelClass small strong text-secondary mb-1">{{'shipment.invoice.materialName' | cxTranslate}}</label>
			<p class="fieldClass mb-0 attach-value">{{  (batchData?.productName || batchData?.material || '-- --')}}</p>

		</div>
	</div>

	<div class="invoice-meta p-3 mb-3">
		<div class="row mb-3">
			<div class="col-md-4 col-sm-12 mb-3 mb-md-0" *ngIf="fromPortInvoice">
				<label class="small strong text-secondary mb-1">{{'shipment.invoice.InvoiceType' | cxTranslate}}</label>
				<select class="form-control" [(ngModel)]="selectedInvoiceType" (change)="onInvoiceTypeChange($event)" [disabled]="invoiceResponse?.invoiceType || showConfirmation || invoiceResponse?.sesShowStatus === 'Success'">
					<option *ngFor="let option of invoiceTypeOptions" [value]="option?.value">{{ option?.label }}</option>
				</select>
			</div>
			<div class="col-md-4 col-sm-12 mb-3 mb-md-0">
				<label class="small strong text-secondary mb-1">{{'shipment.invoice.vatInvoiceNo' | cxTranslate}}</label>
				<p class="fieldClass mb-0">{{ invoiceResponse?.externalNumber || '-- --' }}</p>
			</div>
			<div class="col-md-4 col-sm-12">
				<label class="small strong text-secondary mb-1">{{'shipment.invoice.purchaseOrderNo' | cxTranslate}}</label>
				<p class="fieldClass mb-0">{{ invoiceResponse?.purchaseOrderNumber || '-- --' }}</p>
			</div>
			<div class="col-md-4 col-sm-12 mb-3 mb-md-0" *ngIf="!fromPortInvoice">
				<label class="small strong text-secondary mb-1">{{'shipment.invoice.invoiceDate' | cxTranslate}}</label>
				<p class="fieldClass mb-0">{{ transformedDate || '-- --' }}</p>
			</div>
		</div>
		<div class="row mb-3">
			<div class="col-md-4 col-sm-12 mb-3 mb-md-0" *ngIf="fromPortInvoice">
				<label class="small strong text-secondary mb-1">{{'shipment.invoice.invoiceDate' | cxTranslate}}</label>
				<p class="fieldClass mb-0">{{ transformedDate || '-- --' }}</p>
			</div>
			<div class="col-md-4 col-sm-12">
				<label class="small strong text-secondary mb-1">{{'shipment.invoice.exclTotalAmount' | cxTranslate}}</label>
				<p class="fieldClass mb-0">{{ invoiceResponse?.grossPrice || '-- --' }}</p>
			</div>
			<div class="col-md-4 col-sm-12">
				<label class="small strong text-secondary mb-1">{{'shipment.invoice.inclTotalAmount' | cxTranslate}}</label>
				<p class="fieldClass mb-0">{{ invoiceResponse?.grossPriceInclTax || '-- --' }}</p>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12 col-sm-12">
				<label class="small strong text-secondary mb-1">{{'shipment.invoice.itemCharge' | cxTranslate}}</label>
				<p class="fieldClass mb-0">{{ invoiceResponse?.itemCharge || '-- --' }}</p>
			</div>
		</div>
	</div>
	<!-- <div class="col-md-12 col-sm-12 px-0">
        <div
          *ngIf="(invoiceResponse?.azureStatus | lowercase)=='not_initiated'"
          class="mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F;display: flex; border-radius: 4px;">
          <img src="/images/info.svg" ngbTooltip="{{'home.recordpickup.AzureNotValidated' | cxTranslate}}" alt="Not yet validated" width="20px" height="20px">
          <span class="ml-2">{{'home.recordpickup.validationResults' | cxTranslate}}</span>

        </div>
        <div *ngIf="(invoiceResponse?.azureStatus | lowercase)=='in_progress'"
          class="mt-2 p-2 mb-3"
          style="font-size: 0.95rem; border: 1px solid #bdbdbd; background: #84B5D91F;display: flex; border-radius: 4px;">
          <img src="/images/pending.svg" ngbTooltip="{{'home.recordpickup.AzureValidating' | cxTranslate}}" alt="In progress" width="20px" height="20px">
          <span class="ml-2">{{'home.recordpickup.dataSubmitted' | cxTranslate}}</span>

        </div>
        
        <div *ngIf="(invoiceResponse?.azureStatus | lowercase) === 'failure'"
          class="text-danger mt-2 p-2 mb-3 azureResponse"
          style="color: #5C1715">
          <img src="/images/warning.svg" ngbTooltip="{{'home.recordpickup.AzureUnsuccessfulValidation' | cxTranslate}}" alt="Unsuccessful validation" width="20px"
            height="20px">
          <span class="ml-2" style="white-space: pre-line;" [innerHTML]="htmlOutput"></span>
        </div>
        
         <div *ngIf="(invoiceResponse?.azureStatus | lowercase) === 'success'"
          class="text-success mt-2 p-2 mb-3 azureResponse"
          style="color: #28A745">
          <img src="/images/check_circle.svg" ngbTooltip="{{'home.recordpickup.AzureValidatedSuccessfully' | cxTranslate}}" alt="Validated successfully"
            width="20px" height="20px">
          <span class="ml-2" style="white-space: pre-line;" [innerHTML]="htmlOutput"></span>
        </div>

      </div> -->
	<div *ngIf="!showConfirmation" class="dropdiv mb-4" (dragover)="onDragOver($event)" (drop)="onDropSuccess($event)">
			<div class="d-flex justify-content-between align-items-center flex-wrap upload-zone-content">
				<div class="d-flex align-items-center mb-3 mb-md-0">
					<img src="../../images/upload-img.svg" class="upload-icon" alt="Upload">
					<div>
						<p class="mb-1">{{'shipment.invoice.SelectFileDragDrop' | cxTranslate}}</p>
						<p class="mb-0 text-secondary upload-hint">{{'shipment.invoice.fileSizeLimit' | cxTranslate}}</p>
					</div>
				</div>

				<label class="custom-file-upload btn btn-secondary select-file-btn mb-0">
					<input accept="application/pdf, image/jpg, image/jpeg, image/png" (onFileSelected)="onChange($event)" type="file"
						ng2FileSelect [uploader]="uploader" [disabled] = "invoiceResponse?.sesShowStatus === 'Success'"/>
					{{'shipment.invoice.SelectFile' | cxTranslate}}
				</label>
			</div>
		</div>

		<div *ngIf="filesTopushForCall.length" class="mb-4">
			<div class="filesection-mobile-check mt-2" *ngFor="let file of filesTopushForCall; let i = index">
				<div class="d-flex file-block-height">
					<div class="d-flex w-100 m-2">
						<div class="d-flex align-items-center"><img src="../../images/file-alt.svg" class="p-2" alt="File"></div>
						<div class="p-2 w-100 text-break">
							 <p class="file_name file-name-height-1">{{file.name || file.documentName}}<a
                          *ngIf="file.downloadURL!=undefined" class="pt-2 btn btn-sm text-primary shadow-none small"
                          href="{{file.downloadURL}}">{{'shipment.invoice.Preview' | cxTranslate}}</a></p>
							<p class="file_size text-secondary">{{ file.size / 1024 / 1024 | number: '.3' }}MB</p>
						</div>
						<div>
							<i *ngIf="!showConfirmation" class="fa fa-times close-icon-file p-2" aria-hidden="true" (click)="removeInvoice(i)"></i>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="empty-invoice-state text-center" *ngIf="!uploadedInvoices.length && !showConfirmation">
			<p class="empty-title mb-1">{{'shipment.invoice.NoInvoicesAttachedYet' | cxTranslate}}</p>
			<p class="text-secondary mb-0">{{'shipment.invoice.NoInvoicesAttachedYetMsg' | cxTranslate}}</p>
		</div>
		 <div class="col-md-12 col-sm-12" *ngIf="showConfirmation && !invoiceResponse?.isSesInvoiceCreated">
        <div class="mt-2 p-2 d-flex" style="font-size: 0.95rem; border: 1px solid #ffc107; border-radius: 4px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 20 20" fill="none">
                <path
                    d="M3.72494 17.087H16.2749C17.5583 17.087 18.3583 15.6953 17.7166 14.587L11.4416 3.74531C10.7999 2.63698 9.19994 2.63698 8.55827 3.74531L2.28327 14.587C1.6416 15.6953 2.4416 17.087 3.72494 17.087ZM9.99994 11.2536C9.5416 11.2536 9.1666 10.8786 9.1666 10.4203V8.75365C9.1666 8.29531 9.5416 7.92031 9.99994 7.92031C10.4583 7.92031 10.8333 8.29531 10.8333 8.75365V10.4203C10.8333 10.8786 10.4583 11.2536 9.99994 11.2536ZM10.8333 14.587H9.1666V12.9203H10.8333V14.587Z"
                    fill="#ffc107" />
            </svg>
            <span class="ml-2"> Once submitted, changes cannot be reversed. Ensure all entries and attached file have been
                validated. Select confirm and proceed.</span>
        </div>
    </div>
	<div *ngIf="!showConfirmation && (invoiceResponse?.azureStatus|lowercase) =='rejected'">
		<label class="small strong text-secondary mb-1">Rejection Remarks</label>
		<textarea class="form-control mt-2" rows="3" readonly>{{ invoiceResponse?.rejectionReason || 'No comments from Azure' }}</textarea>	

	</div>
	

	
</div>
<div class="modal-footer"  *ngIf="!enableLoader">
		<div class="w-100 d-flex justify-content-between align-items-center">
			<div class="d-flex align-items-center" style="gap:8px" *ngIf="uploadedInvoices.length && !showConfirmation && !rejectConfirmation && !invoiceResponse?.isSesInvoiceCreated">
		
					<button style="gap:8px"
						*ngIf="((invoiceResponse?.azureStatus | lowercase)=='not_initiated' ) && (!fromPortInvoice || !!selectedInvoiceType)"
						type="button" class="btn btn-block  btn-validate action-btn d-flex align-items-center"
						 (click)="onValidate()">
						<img src="/images/validate.svg" alt="Validate" width="20px" height="20px"> {{'shipment.invoice.Validate' | cxTranslate}}
					</button>
					<button
						*ngIf="(((invoiceResponse?.azureStatus | lowercase)=='failure' || (invoiceResponse?.azureStatus | lowercase)=='in_progress') ||  (invoiceResponse?.azureStatus | lowercase)=='rejected') && (!fromPortInvoice || !!selectedInvoiceType)"
						type="button" 
						class="btn btn-block  btn-validate action-btn d-flex align-items-center" (click)="onRevalidateClick()"
						[disabled]="(invoiceResponse?.azureStatus | lowercase)=='in_progress' && !showRevalidateButton"
						style="display: flex; align-items: center; gap: 10px">
						<span *ngIf="(invoiceResponse?.azureStatus | lowercase)=='in_progress' && !showRevalidateButton" 
							class="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>
						<img *ngIf="(invoiceResponse?.azureStatus | lowercase)=='failure' || (invoiceResponse?.azureStatus | lowercase)=='rejected' || showRevalidateButton" src="/images/restart_alt.svg" alt="Re-validate"
							width="20px" height="20px">{{'shipment.invoice.Revalidate' | cxTranslate}}</button>
					<button *ngIf="(invoiceResponse?.azureStatus | lowercase)=='in_progress' && !showRevalidateButton" type="button"
						class="btn btn-validate action-btn" (click)="onReload()"> {{'shipment.invoice.Reload' | cxTranslate}} </button>
				
				
			</div>
			
			<div class="d-flex ml-auto">
				
					<button 
					*ngIf="showConfirmation && !invoiceResponse?.isSesInvoiceCreated"
					class="btn btn-warning action-btn" 
					type="button"
					(click)="submit(true)"
				>
					<i class="fa fa-save mr-1" aria-hidden="true"></i>
					{{'shipment.invoice.Submit' | cxTranslate}}
				</button>
				<button *ngIf="(invoiceResponse?.azureStatus | lowercase) == 'not_initiated' && !showConfirmation"
					class="btn btn-warning action-btn" type="button" (click)="onSave(true)">
					<i class="fa fa-save mr-1" aria-hidden="true"></i>
					{{'shipment.invoice.Save' | cxTranslate}}
				</button>
				  <button *ngIf="filesTopushForCall.length>0 && (invoiceResponse?.azureStatus | lowercase)!='not_initiated' && !showConfirmation && !invoiceResponse?.isSesInvoiceCreated" [disabled]="(invoiceResponse?.azureStatus | lowercase) == 'not_initiated'" class="btn btn-primary action-btn" type="button" (click)="onNext()">
                {{'shipment.invoice.Next' | cxTranslate}}
            </button>
				 <button *ngIf="!fromPortInvoice  && (!showConfirmation || invoiceResponse?.isSesInvoiceCreate)" class="btn btn-light action-btn ml-2" type="button" (click)="onCancel()">{{'shipment.invoice.Cancel' | cxTranslate}}</button>
            <button *ngIf="fromPortInvoice  || (showConfirmation && !invoiceResponse?.isSesInvoiceCreated) " class="btn btn-light action-btn ml-2" type="button" (click)="onBack()">{{'shipment.back' | cxTranslate}}</button>

			</div>
		</div>
	</div>